import { gql, useMutation } from '@apollo/client';

const INSERT_PROGRAM_TO_CART = gql`
mutation InsertToCart($programId: Uuid = "", $status: Text = "", $userId: Int4 = "", $organisationId: Uuid = "") {
  v2InsertCart(
    objects: {userId: $userId, programId: $programId, status: $status, organisationId: $organisationId}
  ) {
    affectedRows
  }
}
`;

const INSERT_COURSE_TO_CART = gql`
mutation InsertToCart($courseId: Uuid = "", $status: Text = "", $userId: Int4 = "", $organisationId: Uuid = "") {
  v2InsertCart(
    objects: {userId: $userId, courseId: $courseId, status: $status, organisationId: $organisationId}
  ) {
    affectedRows
  }
}
`;


const useAddToCart = () => {
  const [insertProgramToCart, { data: programData, loading: programLoading, error: programError }] = useMutation(INSERT_PROGRAM_TO_CART,
    {
      context: {
        headers: {
          "x-hasura-role": "learner",
        },
      },
    }
  );

  const [insertCourseToCart, { data: courseData, loading: courseLoading, error: courseError }] = useMutation(INSERT_COURSE_TO_CART,
    {
      context: {
        headers: {
          "x-hasura-role": "learner",
        },
      },
    }
  );

  return { insertProgramToCart, insertCourseToCart, programData, programLoading, programError, courseData, courseLoading, courseError };
}

export default useAddToCart;
